<template>
	<div>
		<div style="width:1200px;margin: 0 auto;">
			<div class="dingdan">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item>个人中心</el-breadcrumb-item>
				  <el-breadcrumb-item>个人信息</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<ul class="userbox">
				<li>
					<div class="userbox1">
						<div>头像</div>
						<img :src="user.avatar" alt="" srcset="" />
					</div>
					<input
						ref="avatarInput"
						type="file"
						accept="image/*"
						style="display:none"
						@change="onAvatarFileChange"
					/>
					<p @click="touxiang">更换头像</p>
				</li>
				<li>
					<div class="userbox1">
						<div>昵称</div>
						<span>{{user.nickname}}</span>
					</div>
					<p @click="geteast">编辑昵称</p>
				</li>
				<li>
					<div class="userbox1">
						<div>手机号码</div>
						<span>{{user.phone}}</span>
					</div>
					<p></p>
				</li>
				<li v-if="brokerage=='1'">
					<div class="userbox1">
						<div>邀请好友</div>
						<span>分享好友</span>
					</div>
					<p @click="fenxiang">生成邀请链接</p>
				</li>
			</ul>
			<diV class="userbox" 
			    style="margin-top:20px;">
				<div class="kpTitle">
					<h4>开票信息</h4>
					<span @click="type=!type">编辑</span>
				</div>
				<ul class="userbox" style="padding: 0;">
					<li>
						<div class="userbox1">
							<div>公司信息</div>
							<span v-if="type">{{user.company_name || '暂未添加'}}</span>
							<input v-if="!type" type="text" placeholder="请输入公司信息" v-model="user.company_name">
						</div>
						<p></p>
					</li>
					<li>
						<div class="userbox1">
							<div>公司税号</div>
							<span v-if="type">{{user.tax_id  || '暂未添加'}}</span>
							<input  v-if="!type" type="text" placeholder="请输入公司税号" v-model="user.tax_id">
						</div>
						<p></p>
					</li>
					<li>
						<div class="userbox1">
							<div>邮箱信息</div>
							<span v-if="type">{{user.email || '暂未添加'}}</span>
							<input v-if="!type" type="text" placeholder="请输入内容" v-model="user.email">
						</div>
						<p></p>
					</li>
				</ul>
			</diV>
			<div style="padding-top:10px;width:100%;display:flex;justify-content:end;">
				<p>
					<span @click="xieyi(1)" style="cursor:pointer;">《隐私政策》</span>
					<span @click="xieyi(2)" style="cursor:pointer;">《用户协议》</span>
					<span @click="xieyi(3)" style="cursor:pointer;">《平台协议》</span>
					<span @click="xieyi(4)" style="cursor:pointer;">《评审说明》</span>
					<span @click="xieyi(5)" style="cursor:pointer;">《分销规则》</span>
				</p>
			</div>
			<div class="FBxqFooter">
				<div class="FBxqFooter1" @click="tuichu">退出登录</div>
				<div class="FBxqFooter2" @click="tijiao">保存</div>
			</div>
		</div>
		<el-dialog
		  title="修改昵称"
		  :visible.sync="centerDialogVisible"
		  width="400px"
		  center>
		  <el-input v-model="inputname" placeholder="请输入新的昵称"></el-input>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="getname">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import {
		personal,
		UserUpdate,
		upload,
		BaseGetConfig
		// Userlogout
	} from "@/api/api.js"
	// import rightsidebarImg from '@/common/rightsidebarImg.vue';
	export default {
	  name: 'HelloWorld',
	 //  components:{
		// rightsidebarImg  
	 //  },
	  data() {
	    return {
			radio:'1',
			type: true,
			centerDialogVisible:false,
			inputname:"",
			valiFormData: {
				company_name: '',
				tax_id:'',
				email:"",
			},
			brokerage:""
	    }
	  },
	   computed: {
	  	  	...mapState({
	  	  		user: (state) => state.userInfo || {}
	  	  	})
	  	},
	  created() {
	  	this.userinfo()
		this.getfenxiang()
	  },
	  methods: {
		  getfenxiang(){
		  	BaseGetConfig({
		  		key:"brokerage_switch"
		  	}).then(res=>{
		  		this.brokerage=res.data.data.brokerage_switch
		  	})
		  },
		   xieyi(e){
		  		this.$router.push('/Agreement?type='+e)
		   },
		  fenxiang(){
			let text='https://demandweb.jckj928.cn/?invite_code='+this.user.invite_code
			try {
				navigator.clipboard.writeText(text);
				this.$message.success('生成邀请链接成功')
			} catch (err) {
				this.$message.error('生成邀请链接失败')
			}
		  },
		  touxiang(){
		  	this.$refs.avatarInput && this.$refs.avatarInput.click()
		  },
		  onAvatarFileChange(e) {
		  	const input = e.target
		  	const file = input.files && input.files[0]
		  	input.value = ''
		  	if (!file) return
		  	if (!/^image\//.test(file.type)) {
		  		this.$message.warning('请选择图片文件')
		  		return
		  	}
		  	const maxSize = 2 * 1024 * 1024
		  	if (file.size > maxSize) {
		  		this.$message.warning('图片大小不能超过 2MB')
		  		return
		  	}
		  	const formData = new FormData()
		  	formData.append('file', file)
		  	upload(formData, {
		  		transformRequest: [
		  			(data, headers) => {
		  				if (data instanceof FormData) {
		  					delete headers['Content-Type']
		  				}
		  				return data
		  			}
		  		]
		  	}).then((res) => {
		  		if(res.data.status==200){
		  			this.getUserUpdate(res.data.data)
		  		}else{
		  			 // this.$message.error(res.data.msg)
		  		}
		  	})
		  },
		  geteast(){
			  this.inputname=''
			  this.centerDialogVisible=true
		  },
		  getname(){
			  if(this.inputname==''){
				  this.$message.error("新的昵称不能为空")
				  return false
			  }
			  UserUpdate({
			  	nickname:this.inputname
			  }).then(res=>{
			  	if(res.data.status==200){
					this.centerDialogVisible=false
			  		this.userinfo()
			  	}else{
			  		// this.$message.error(res.data.msg)
			  	}
			  })
		  },
		  // 更新个人信息
		  getUserUpdate(img){
		  	UserUpdate({
		  		avatar:img
		  	}).then(res=>{
		  		if(res.data.status==200){
		  			this.userinfo()
		  		}else{
		  			// this.$message.error(res.data.msg)
		  		}
		  	})
		},
		userinfo(){
			return this.$store.dispatch('fetchPersonal').then(() => {
				const u = this.user
				if (u && u.review_status == 1) {
					this.value = true
				} else {
					this.value = false
				}
			})
		},
		tuichu(){
		   // 清理登录态与缓存
		   localStorage.removeItem("token")
		   localStorage.removeItem("userinfo")
		   localStorage.setItem("userType","1")
		   sessionStorage.clear()
		   // 提示并返回首页，尽可能避免保留历史记录
		   this.$message.success('退出登录成功')
		   setTimeout(()=>{
		   	 // 路由层替换当前记录
		   	 this.$router.replace('/')
		   	 // 浏览器层替换，阻断后退到受保护页
		   	 this.$nextTick(()=>{
		   	 	window.location.replace('/')
		   	 })
		   },800)
		},
		tijiao(){
			if(this.type){
				return false
			}
			UserUpdate({
				company_name:this.user.company_name,
				tax_id:this.user.tax_id,
				email:this.user.email,
			}).then(res=>{
				if(res.data.status==200){
					 this.$message.success('提交成功')
					 this.type=true
					 this.userinfo()
				}else{
					 // this.$message.error(res.data.msg)
				}
			})
		}
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.userbox{
		width:100%;
		background-color:#fff;
		padding:12px;
		box-sizing: border-box;
		border-radius:12px;
	}
	.userbox img{
		width: 42px;
		height:42px;
		border-radius:50%;
	}
	.userbox li{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		padding: 10px 0px;
	}
	.userbox1{
		display:flex;
		align-items: center;
	}
	.userbox1 div{
		width: 160px;
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.userbox1 span{
		font-weight: 500;
		font-size: 16px;
		color: #333333;
	}
	.userbox1 input{
		width:300px;
		height:30px;
		border-radius: 6px;
		border:1px solid #666666;
		outline:none;
		padding-left:5px;
	}
	.userbox li>p{
		font-weight: 500;
		font-size: 16px;
		color: #4297FF;
		cursor:pointer;
	}
	
	.FBxqFooter{
		width:100%;
		padding:30px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.FBxqFooter1{
		width: 112px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px ;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #1E3A8A;
		cursor:pointer;
	}
	.FBxqFooter2{
		width: 112px;
		height: 40px;
		background: #1E3A8A;
		border-radius: 8px ;
		margin-left:32px;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		cursor:pointer;
	}
	.kpTitle{
		width:100%;
		display:flex;
		align-items:center;
		justify-content:space-between;
	}
	.kpTitle h4{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.kpTitle span{
		font-weight: 500;
		font-size: 16px;
		color: #4297FF;
		cursor:pointer;
	}
</style>